<script>

	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';

	import { fade, slide } from 'svelte/transition';
  	
	const dispatch = createEventDispatcher()

    let error = ""
	let visible = false

    onMount(async () => {})

	export const start = async () => {
		visible = true
	}

	export const stop = (action = 'close', data = {}) => {
		dispatch('message', {
			action : action,
            data : data
		})
        error = ""
		visible = false
	}

    const handleFinished = () => {
        stop("finished")
    }

</script>

{#if visible}
    <div class="fullscreen" transition:fade="{{ y: 200, duration: 200 }}"></div>
    <div class="container main-modal" transition:slide="{{ x: -200, duration: 200 }}">
        <div id="carouselExampleIndicators" class="carousel carousel-dark slide" data-bs-ride="false" data-bs-interval="false">
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>
            <div class="carousel-inner text-left">
              <div class="carousel-item active">
                <h3 class="mb-4">Bienvenue !</h3>
                <p>Tu trouveras ici un ensemble de services qui peuvent t'aider au quotidien.</p>
                <p>Voici quelques exemples :</p>
                <ul>
                    <li>Un <b>serveur de streaming</b> 🎥</li>
                    <li>Un <b>gestionnaire de mot de passe</b> 🔐</li>
                    <li>Un <b>espace de stockage privé</b> 🗂️ pour sauvegarder tes données</li>
                </ul>
              </div>
              <div class="carousel-item">
                <h3>Première connexion ?</h3>
                <p>Si c'est ta première connexion, je t'invite à aller voir en premier lieu la page d'aide qui va te détailler tous les services disponibles et comment les utiliser.</p>
                <p>‼️ Deux choses importantes quand même :</p>
                <ul>
                    <li>Ton <b>identifiant</b> sur les services sera toujours le même que celui utilisé ici à savoir <b>prenom-nom</b> sans accents 👤</li>
                    <li>Tes <b>mots de passe</b> t'ont été envoyés par un autre canal 🔑</li>
                </ul>
                <p></p>
                <div class=" mt-4">
                    <a type="button" href="https://help.adr1.fr" target="__blank" class="btn btn-info">
                        <img class="small-help-icon" src="/icons/help.png" alt=""/>
                        Aide
                    </a>
                </div> 
              </div>
              <div class="carousel-item">
                <h3>Bonne découverte !</h3>
                <div class=" mt-4">
                    <button type="button" on:click={handleFinished} class="btn btn-success">Découvrir !</button>
                </div>  
              </div>
            </div>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
    </div>
{/if}

<style>

    .fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom : 0;
        background-color: rgba(0, 0, 0, 0.33);
    }

	.main-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 15px;
        max-width: 100%;
        padding: 10px;
        max-height: 100%;
        width: 500px;
        overflow: auto;
	}

    .carousel-indicators {
        margin: 0;
    }

    .carousel-control-next {
        width: auto;
    }

    .carousel-inner {
        padding: 30px 45px 30px 15px;
    }

    .small-help-icon {
        width: 30px;
        margin-right: 10px;
    }

</style>
